import { useFlags } from 'launchdarkly-react-client-sdk';

export const useFeatureCanAccessNativeFeedbackSurvey = () => {
  const flags = useFlags();
  return flags.contentRatings;
};
